import {
  NEWDANHMUCKHOHANG_COUNT_ASSIGN_SUCCESS,
  NEWDANHMUCKHOHANG_HISTORY_LIST_SUCCESS,
  NEWDANHMUCKHOHANG_IMPORT_SUCCESS,
  NEWDANHMUCKHOHANG_LIST_SUCCESS,
  NEWDANHMUCKHOHANG_NEW_CARE_SUCCESS,
  NEWDANHMUCKHOHANG_ONE_SUCCESS,
  NEWDANHMUCKHOHANG_UPDATE_FILTER,
  NEWDANHMUCKHOHANG_SAVE_SUCCESS,
  NEWDANHMUCKHOHANG_UPDATE_HOMEPAGE_FILTER,
  NEWDANHMUCKHOHANG_HOMEPAGE_LIST_SUCCESS,
  NEWDANHMUCKHOHANG_HOMEPAGE_ONE_SUCCESS,
  NEWDANHMUCKHOHANG_HANDLE_IMPORT_ERRORS,
} from 'src/actions/newdanhmuckhohang.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    so_dien_thoai: '',
    loai_sim: {},
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageNewdanhmuckhohangFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageNewdanhmuckhohangPage: 0,
    homepageNewdanhmuckhohangLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,
  homepageNewdanhmuckhohangItems: [],
  homepageNewdanhmuckhohangTotal: 0,
  homepageNewdanhmuckhohangSelected: undefined,
  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_upgoicuoc: [],
  errorRows: {},
}

const newdanhmuckhohangReducer = (state = initState, action) => {
  switch (action.type) {
    case NEWDANHMUCKHOHANG_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case NEWDANHMUCKHOHANG_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case NEWDANHMUCKHOHANG_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case NEWDANHMUCKHOHANG_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageNewdanhmuckhohangFilter !== 'undefined' && state.homepageNewdanhmuckhohangFilter) {
        if (action.data.homepageNewdanhmuckhohangPage == 'no_update' && typeof state.homepageNewdanhmuckhohangFilter.homepageNewdanhmuckhohangPage !== 'undefined') action.data.homepageNewdanhmuckhohangPage = state.homepageNewdanhmuckhohangFilter.homepageNewdanhmuckhohangPage;
        if (action.data.homepageNewdanhmuckhohangLimit == 'no_update' && typeof state.homepageNewdanhmuckhohangFilter.homepageNewdanhmuckhohangLimit !== 'undefined') action.data.homepageNewdanhmuckhohangLimit = state.homepageNewdanhmuckhohangFilter.homepageNewdanhmuckhohangLimit;
      }
      return {
        ...state,
        homepageNewdanhmuckhohangFilter: action.data,
      }
    }
    case NEWDANHMUCKHOHANG_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmuckhohangItems: action.data.homepageNewdanhmuckhohangItems,
        homepageNewdanhmuckhohangTotal: action.data.homepageNewdanhmuckhohangTotal,
      }
    }
    case NEWDANHMUCKHOHANG_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmuckhohangSelected: action.data
      }
    }
    case NEWDANHMUCKHOHANG_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case NEWDANHMUCKHOHANG_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case NEWDANHMUCKHOHANG_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case NEWDANHMUCKHOHANG_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case NEWDANHMUCKHOHANG_SAVE_SUCCESS: {
      return {
        ...state,
        temp_upgoicuoc: []
      }
    }
    case NEWDANHMUCKHOHANG_HANDLE_IMPORT_ERRORS: {
      return {
        ...state,
        errorRows: action.data,
      }
    }
    default: {
      return state;
    }
  }
}
export default newdanhmuckhohangReducer